import { useEffect } from "react";
import { useSearchCountsWithNextCursorFetcher } from "../searchCounts";
import AllContentResultsChunk from "./AllContentResultsChunk";
import { ManageAssetWithLicense } from "../../../../../common/api/decimal/common-types/manageAssets";
import { useSearchParams } from "react-router-dom";
import { SearchSection } from "../types.ts";

export default function LoadableAllContentResults({
  cursor,
  setNextCursor,
  openPanel,
  setIsLoading,
}: {
  cursor: string | undefined;
  setNextCursor: (cursor: string | undefined) => void;
  openPanel: (asset: ManageAssetWithLicense, section: SearchSection) => void;
  setIsLoading: (isLoading: boolean) => void;
}) {
  const fetcher = useSearchCountsWithNextCursorFetcher();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const fetchResults = (cursor: string) => {
      fetcher.load(
        `/search/api/paginated-counts/${cursor}?${searchParams.toString()}`
      );
    };

    if (cursor && fetcher.state === "idle" && !fetcher.data) {
      fetchResults(cursor);
    }

    if (fetcher.state === "loading") {
      setIsLoading(true);
    }

    if (fetcher.state === "idle" && fetcher.data) {
      setNextCursor(fetcher.data?.results?.nextCursor);

      if (
        fetcher.data?.results?.nextCursor &&
        !fetcher.data?.results?.allResults?.length
      ) {
        fetchResults(fetcher.data?.results.nextCursor);
      } else {
        setIsLoading(false);
      }
    }
  }, [cursor, fetcher, searchParams, setNextCursor, setIsLoading]);

  if (fetcher.data?.results?.allResults?.length) {
    return (
      <AllContentResultsChunk
        results={fetcher.data.results.allResults}
        openPanel={openPanel}
      />
    );
  }
}
